import { FaWhatsapp } from "react-icons/fa";

function FloatingEnquiry() {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[9999]">
      <div className="relative">

        {/* Enquiry Tab */}
        <button
          className="
            w-12
            h-44
            bg-white
            rounded-l-2xl
            border border-slate-200
            shadow-xl
            flex
            items-center
            justify-center
            hover:bg-slate-50
            transition-all
          "
        >
          <span
            className="
              [writing-mode:vertical-rl]
              tracking-[0.35em]
              text-[#163A63]
              text-sm
              font-semibold
            "
          >
            ENQUIRY
          </span>
        </button>

        {/* WhatsApp */}
        <a
          href="https://wa.me/971526013353"
          target="_blank"
          rel="noopener noreferrer"
          className="
            absolute
            -bottom-5
            left-1/2
            -translate-x-1/2
            w-12
            h-12
            rounded-full
            bg-[#25D366]
            text-white
            flex
            items-center
            justify-center
            shadow-xl
            hover:scale-110
            transition-all
          "
        >
          <FaWhatsapp size={24} />
        </a>

      </div>
    </div>
  );
}

export default FloatingEnquiry;